import React, { useEffect, useRef, useState } from "react";
import { createAddressEvent, formatBookingJson, getFormDataForStorage, manualGoogleEvents } from '../helpers/helpers'
import { GooglePlaceAutocomplete, SelectInput } from '@hometown/react-hometown-lib';
import CircularProgress from '@mui/material/CircularProgress';

const IconHome = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
    </svg>
);

const IconWork = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"/>
    </svg>
);

const options = [
    {
      "value": "1",
      "label": "Trash"
    },
    {
      "value": "2",
      "label": "Construction Debris"
    },
    {
      "value": "3",
      "label": "Concrete"
    },
    {
      "value": "4",
      "label": "Roofing"
    },
    {
      "value": "5",
      "label": "Yard Waste"
    },
    {
      "value": "6",
      "label": "Dirt"
    },
    {
      "value": "7",
      "label": "Rock or Brick"
    }
]

const ViewDumpsterPricesForm = ({ state, btnLabel, onSubmit, id }) => {
    const dataFromStorage = getFormDataForStorage(); 
    let addressData = dataFromStorage?.addressData ? { ...dataFromStorage.addressData } : {};
    let defaultWasteType = dataFromStorage?.wasteType || '';
    const [googlePlace, setGooglePlace] = useState('');
    const [isError, setIsError] = useState(false);
    const [selectedWasteType, setSelectedWasteType] = useState(defaultWasteType);
    const [formValues, setFormValues] = useState(addressData ? { ...addressData } : {});
    const [isSubmitting, setIsSubmitting] = useState(false);
    // Resolved in background when user selects address, passed to formatBookingJson on submit
    const resolvedPlaceIdRef = useRef(null);
    const [userType, setUserType] = useState('homeowner');

    useEffect(() => {
        const stored = localStorage.getItem('userType');
        if (stored) setUserType(stored);
    }, []);

    useEffect(() => {
      const element = document.getElementById("waste-type-select");
      if (!element) return;

      if (selectedWasteType) {
        element.classList.add("select-shrink");
      } else {
        element.classList.remove("select-shrink");
      }
    }, [selectedWasteType]);

    const handleSubmit = async () => {
      let hasError = false;
      if(!selectedWasteType) { setIsError(true); hasError = true; }
      if(!formValues.odf_postal_code) hasError = true;
      const formattedValues = formatBookingJson({ ...formValues, wasteType: selectedWasteType }, resolvedPlaceIdRef.current);
      if(hasError) return;
      try {
        setIsSubmitting(true);
        setIsError(false);
        localStorage.setItem('userType', userType);
        if(onSubmit) {
          await onSubmit(formattedValues);
        } else {
          manualGoogleEvents('manualFormSubmition');
          window.location.href = '/book';
        }
      } catch (error) {
        console.log('error', error)
      } finally {
        setIsSubmitting(false);
      }
    }

    const handleUserTypeChange = (type) => {
      setUserType(type);
      localStorage.setItem('userType', type);
    };

    const handleWasteChange = (wasteType) => {
      if(wasteType){
        setIsError(false);
        setSelectedWasteType(wasteType)
      } else {
        setIsError(true)
      }
    }

    const handleAddressChange = (place) => {
      setGooglePlace(JSON.stringify(place))
      let addressValues = {}
      place.map((value) => {
          addressValues["odf_" + value[0]] = value[1]
      })
      createAddressEvent({
        street1: addressValues.odf_street,
        street2: addressValues.odf_street2,
        city: addressValues.odf_locality,
        zipCode: addressValues.odf_postal_code,
        state: addressValues.odf_state
      })
      setFormValues({ ...addressValues })


      // Resolve placeId in background so it's ready when user hits submit
      resolvedPlaceIdRef.current = null;
      const zip = addressValues.odf_postal_code;
      const city = addressValues.odf_locality;
      if (zip && city) {
        fetch(
          `${process.env.GATSBY_DRUPAL_API_MANAGMENT}/place-by-zip-and-name/${zip}/${city}`,
          { headers: { 'Ocp-Apim-Subscription-Key': '30ca1663de42420bb4a9894d1898e91e' } }
        )
        .then(res => res.json())
        .then(data => { if (data?.id) resolvedPlaceIdRef.current = +data.id; })
        .catch(() => {});
      }
    }

    return (
        <div className="prices-form">
          {state &&
            <div class="prices-title">
                <h3>View dumpsters for rent in {state}</h3>
            </div>
            }
            <div className="address-ondeff">
              <GooglePlaceAutocomplete
                  id='view-prices-address'
                  name='address'
                  label="Enter delivery address"
                  fieldName="address"
                  placeholder=""
                  apiKey={`${process.env.GATSBY_BOOKABLE_API_AUTOCOMPLETE}`}
                  className="fill-available"
                  resetError = {()=>{}}
                  onResetField = {()=>{setGooglePlace('')}}
                  onChange = {(place) => handleAddressChange(place)}
                  onChangeValue={googlePlace}
                  formValues={formValues}
                  fullWidth
                  alwaysShrink={!!formValues?.odf_postal_code}
                  // showSearchIcon
              />
            </div>
            <div id="waste-type-select" className="select-ondeff outlined-select">
              <SelectInput
                  id={id}
                  className="outlined-select"
                  value={selectedWasteType}
                  name="wasteType"
                  label="Select your waste"
                  data={options}
                  onChange={handleWasteChange}
                  error="Please select an option"
                  isError={isError}
                  fullWidth
              />
            </div>
            <div className="prices-form__user-type">
                <button
                    className={`prices-form__user-type-btn${userType === 'homeowner' ? ' active' : ''}`}
                    onClick={() => handleUserTypeChange('homeowner')}
                    type="button"
                >
                    <IconHome /> Homeowner
                </button>
                <button
                    className={`prices-form__user-type-btn${userType === 'business' ? ' active' : ''}`}
                    onClick={() => handleUserTypeChange('business')}
                    type="button"
                >
                    <IconWork /> Contractor/Business
                </button>
            </div>
            <div className="button-wrapper">
              <button class='view-dumpster-prices' onClick={handleSubmit}>{isSubmitting ? <CircularProgress style={{ color: '#FFF' }} /> : btnLabel}</button>
            </div>
        </div>
    )
}

export default ViewDumpsterPricesForm;
